import { all, call, put, takeEvery } from 'redux-saga/effects';
import { ApiService } from 'web_core_library';
import { TApiFetchResponse } from '../base/types';
import { SubscriptionActions } from './slice';
import SubscriptionService from './subscriptionService';

export function* initSubscriptionSaga() {
  yield call(SubscriptionService.init, ApiService);
  yield call(loadSubscriptions);
  yield call(loadSubscriptionStatusSaga);
}

export function* loadSubscriptionStatusSaga() {
  try {
    const response: TApiFetchResponse<typeof SubscriptionService.getSubscriptionStatuses> = yield call(
      SubscriptionService.getSubscriptionStatuses
    );
    yield put(SubscriptionActions.updateSubscriptionStatus(response.data.subscriptions));
  } catch (error) {
    // ignore errors for now
    // better handling can be implemented later if necessary
  }
}

export function* loadSubscriptions() {
  try {
    const response: TApiFetchResponse<typeof SubscriptionService.getSubscriptions> = yield call(
      SubscriptionService.getSubscriptions
    );
    yield put(SubscriptionActions.updateSubscriptions(response.data.subscriptions));
  } catch (error) {
    // ignore errors for now
  }
}

export default function* statsWatcher() {
  yield all([takeEvery(SubscriptionActions.initSubscription, initSubscriptionSaga)]);
}
